var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilebadge2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15323_31657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5443 1.34132V22.994C29.5443 23.505 29.2683 23.9734 28.8437 24.1863L15.4892 31.2761C15.1495 31.4464 14.7461 31.4464 14.4064 31.2761L1.07319 24.1863C0.648565 23.9521 0.372559 23.505 0.372559 22.994V1.34132C0.372559 0.617432 0.924571 0 1.60397 0H28.3129C28.9923 0 29.5443 0.596141 29.5443 1.34132Z",
    fill: "#6FCD9E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15323_31657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7844 4.13017V21.546C26.7844 21.9931 26.5509 22.3763 26.19 22.568L15.4257 28.2739C15.1285 28.4229 14.7888 28.4229 14.4915 28.2739L9.35357 25.5487L3.72729 22.568C3.36636 22.3763 3.13281 21.9718 3.13281 21.546V4.13017C3.13281 3.49145 3.5999 2.98047 4.19438 2.98047H25.7016C26.2961 2.98047 26.7632 3.49145 26.7632 4.13017H26.7844Z",
    fill: "url(#paint0_radial_15323_31657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7844 4.13017V21.546C26.7844 21.9931 26.5509 22.3763 26.19 22.568L15.4257 28.2739C15.1285 28.4229 14.7888 28.4229 14.4915 28.2739L9.35357 25.5487L3.72729 22.568C3.36636 22.3763 3.13281 21.9718 3.13281 21.546V4.13017C3.13281 3.49145 3.5999 2.98047 4.19438 2.98047H25.7016C26.2961 2.98047 26.7632 3.49145 26.7632 4.13017H26.7844Z",
    stroke: "white",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.7695 5.38673C24.1942 5.38673 24.5339 5.76996 24.5339 6.23836V20.5032C24.5339 20.8225 24.364 21.1206 24.1092 21.2483L15.2983 25.911C15.2983 25.911 15.0859 25.9962 14.9586 25.9962C14.8312 25.9962 14.725 25.9749 14.6189 25.911L10.4151 23.6755L5.80789 21.227C5.55311 21.078 5.38326 20.8012 5.38326 20.4819V6.23836C5.38326 5.76996 5.72297 5.38673 6.14759 5.38673H23.7483M23.7483 5.28027H6.16882C5.6805 5.28027 5.29834 5.70609 5.29834 6.21707V20.4819C5.29834 20.8438 5.48942 21.1632 5.78666 21.3335L10.3938 23.7819L14.5976 26.0175C14.725 26.0813 14.8524 26.1026 14.9798 26.1026C15.1072 26.1026 15.2346 26.0813 15.362 26.0175L24.1729 21.3548C24.4702 21.2058 24.6612 20.8651 24.6612 20.5032V6.23836C24.6612 5.72738 24.2791 5.30156 23.7908 5.30156L23.7483 5.28027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M10.9457 0L0.372559 10.6028V4.42848L4.78866 0H10.9457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M16.4234 0L0.372559 16.0958V12.2848L12.623 0H16.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9583 8.00488L16.211 11.8798C16.3384 12.2843 16.6993 12.5398 17.1239 12.5398H21.1791L17.9095 14.9244C17.5698 15.1586 17.4424 15.6057 17.5698 15.9889L18.8224 19.8638L15.5528 17.4793C15.2131 17.2451 14.7673 17.2451 14.4276 17.4793L11.1579 19.8638L12.4106 15.9889C12.538 15.5844 12.4106 15.1586 12.0709 14.9244L8.80127 12.5398H12.8564C13.2598 12.5398 13.642 12.263 13.7694 11.8798L15.022 8.00488H14.9583Z",
    fill: "#FFD94B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15323_31657",
    x: 2.60291,
    y: 2.64008,
    width: 24.7117,
    height: 26.4661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.19
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15323_31657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15323_31657",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15323_31657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9586 15.691) scale(12.2504 12.2848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7261DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#705FDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6A58DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#604CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#513BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4931DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15323_31657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2545,
    height: 32,
    fill: "white",
    transform: "translate(0.372559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilebadge2);
export default __webpack_public_path__ + "static/media/profilebadge2.59c72d0d2d4c698e7b858a16299c970d.svg";
export { ForwardRef as ReactComponent };